<section class="bucket-files orch-table-panel">
  <app-orchestration-table-heading heading="Bucket files" queryParam="files" [(query)]="fileSearch">
    <p class="bucket-files__name">{{ bucket() }}</p>
    <div tableActions class="table-actions">
      <app-secondary-button title="Close" (action)="closed.emit()"></app-secondary-button>
    </div>
  </app-orchestration-table-heading>
  @if (errorMessage()) {
    <div class="error-message">{{ errorMessage() | translate }}</div>
  }
  <app-data-table
    [columns]="tableColumns()"
    [data]="files()"
    [config]="tableConfig()"
    [loading]="loading()"
    [totalRecords]="total()"
    [pinnedFirst]="pageFirst()"
    (onPage)="onPage($event)"
  ></app-data-table>
</section>

<ng-template #pathTemplate let-row>
  <a
    class="bucket-files__download"
    [href]="row.downloadUrl"
    [attr.download]="row.fileName"
    (click)="$event.stopPropagation()"
  >{{ row.path }}</a>
</ng-template>

<ng-template #actionsTemplate let-row>
  @if (row.previewUrl) {
    <app-table-actions
      [row]="row"
      [actions]="previewActions"
      (viewAction)="openPreview($event)"
    ></app-table-actions>
  }
</ng-template>

@if (preview(); as file) {
  <p-dialog
    [header]="file.fileName"
    [visible]="true"
    [modal]="true"
    [resizable]="false"
    [draggable]="false"
    [style]="{ width: 'min(960px, 94vw)' }"
    (onHide)="closePreview()"
  >
    @if (previewFailed()) {
      <p class="bucket-files__preview-error">{{ 'Preview unavailable' | translate }}</p>
    } @else {
      <img
        class="bucket-files__preview"
        [src]="file.previewUrl"
        [alt]="file.fileName"
        (error)="markPreviewFailed()"
      />
    }
    <p class="bucket-files__preview-download">
      <a class="bucket-files__download" [href]="file.downloadUrl" [attr.download]="file.fileName">{{ 'Download' | translate }}</a>
    </p>
  </p-dialog>
}
